/**
 * @author      esraa.afifi@zumper.com (Esraa Afifi)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { IconProps } from '../../types'

interface ZumperBoltProps extends IconProps {
  bodyFill?: string
  heartFill?: string
}

export const ZumperBolt = ({
  size = 24,
  heartFill = '#E84676',
  bodyFill = '#0D2A3A',
  ...rest
}: ZumperBoltProps) => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 20 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M14.1288 5.75H15.8289C16.3654 5.75 16.8004 6.19774 16.8004 6.75004V11.0002H13.886V6.00001C13.886 5.86193 13.9947 5.75 14.1288 5.75Z"
        fill={bodyFill}
      />
      <path
        d="M2.10697 14.9992H0.486701C0.053962 14.9992 -0.162753 14.4606 0.143244 14.1456L9.65658 4.35251C9.84626 4.15722 10.1538 4.15725 10.3435 4.35251L19.8568 14.1457C20.1628 14.4607 19.946 14.9994 19.5133 14.9993L17.8931 14.9992C17.8261 14.9992 17.7717 15.0552 17.7717 15.1242V22.9998C17.7717 23.5521 17.3367 23.9998 16.8002 23.9998H12.4287C12.1604 23.9998 11.9429 23.7759 11.9429 23.4998V18.4996C11.9429 18.2234 11.7255 17.9995 11.4572 17.9995H8.54286C8.27459 17.9995 8.05713 18.2234 8.05713 18.4996V23.4998C8.05713 23.7759 7.83967 23.9998 7.5714 23.9998H3.19985C2.66334 23.9998 2.2284 23.5521 2.2284 22.9998V15.1242C2.2284 15.0551 2.17402 14.9992 2.10697 14.9992Z"
        fill={bodyFill}
      />
      <path
        d="M17.7629 1.24733C17.6949 0.546671 17.2575 0 16.5706 0C15.9205 0 15.5002 0.622844 15.2787 1.11177C15.2558 1.16227 15.1835 1.16227 15.1606 1.11177C14.9392 0.622844 14.5189 0 13.8688 0C13.1819 0 12.7444 0.546671 12.6764 1.24733C12.6719 1.29401 12.6696 1.34144 12.6696 1.3894C12.6696 2.97378 14.4122 3.77299 15.0991 4.79606C15.1548 4.87908 15.2845 4.87908 15.3403 4.79606C16.0272 3.77304 17.7698 2.97383 17.7698 1.3894C17.7698 1.34144 17.7674 1.29401 17.7629 1.24733Z"
        fill={heartFill}
      />
    </svg>
  )
}
